// Module
var code = `<!-- page html -->
<hs-header></hs-header>
`;
// Exports
export default code;